import React from "react";
import { AchievementsShowcase, Store } from "../../../../../common";

/**
 * Vitrína odznakov prihláseného kužeľníka (profil vpravo hore -> Odznaky, alebo z upozornenia o odznaku).
 * Odznaky ostatných kužeľníkov sa prezerajú v ich profile, v záložke Odznaky.
 */
export default function AchievementsModal() {
    return (
        <AchievementsShowcase
            title={Store.getObject("loggedUser").nickname ?? Store.getObject("loggedUser").name}
            tooltipId="achievementsModalTooltip" />
    );
}
